module.exports = __webpack_public_path__ + "img/k14.a69e070c.png";